import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RequestFormPhone } from '~/src/components/RequestFormPhone';

const breakPoints = {
    tablet: '999px',
};

export const Content = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background: ${COLORS.BgSecondary};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 16px 12px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 16px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 8px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column-reverse;
        padding: 16px;
    }
`;

export const TextContent = styled.div`
    flex-direction: column;
    align-items: flex-start;
    width: 544px;
    margin-left: 112px;
    margin-right: 96px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-left: 38px;
        margin-right: 74px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 345px;
        margin-left: 24px;
        margin-right: 22px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 310px;
        margin-right: 14px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
`;

export const Title = styled.div`
    ${FONTS.H2};
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
        margin-bottom: 8px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
    }
`;

export const Subtitle = styled.div`
    ${FONTS.S};
    max-width: 446px;
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 8px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
    }
`;

export const SRequestFormPhone = styled(RequestFormPhone)`
    & > div {
        grid-template-columns: auto;

        @media (max-width: ${wideBreakpoints.sDesktop}) {
            grid-template-areas:
                'input button'
                'checkbox checkbox';
        }

        @media (max-width: ${wideBreakpoints.laptop}) {
            grid-template-areas:
                'input'
                'checkbox'
                'margin'
                'button';
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            display: flex;
        }
    }

    & > div > button {
        width: 260px;
        margin-left: 16px;

        @media (max-width: ${wideBreakpoints.laptop}) {
            margin-left: 0;
            width: 100%;
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            order: 3;
            margin-top: 18px;
        }
    }

    & > div > div > input {
        width: 260px;

        @media (max-width: ${wideBreakpoints.laptop}) {
            width: 100%;
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            order: 1;
        }
    }

    > div > div {
        > button {
           @media (max-width: ${breakPoints.tablet}) {
               width: 100%;
           }
        }
    }
`;

export const ImgContent = styled.div`
    width: 720px;
    height: auto;
    border-radius: 16px;
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 526px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 372px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: auto;
        margin-bottom: 24px;
    }
`;

export const Image = styled(LazyLoadImage)`
    width: 100%;
    height: 311px;
    object-fit: cover;
    object-position: center;

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 291px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 170px;
    }
`;
